/* Mit dem Editor gelieferte FGD-Dateien (Ordner src/fgd). Sie werden erst beim Bedarf nachgeladen und stehen ohne Upload zur Auswahl. */
const files = import.meta.glob('./*.fgd', { query: '?raw', import: 'default' }) as Record<string, () => Promise<string>>;

const nameOf = (p: string): string => p.replace(/^.*\//, '');

/** Dateinamen der mitgelieferten FGDs, sortiert */
export const bundledNames = (): string[] => Object.keys(files).map(nameOf).sort((a, b) => a.localeCompare(b));

/** Ist die Datei mitgeliefert (ohne Beachtung der Groß-/Kleinschreibung)? */
export const isBundled = (name: string): boolean => bundledNames().some((n) => n.toLowerCase() === name.toLowerCase());

/** Text einer mitgelieferten FGD oder null */
export async function bundledText(name: string): Promise<string | null> {
  const key = Object.keys(files).find((p) => nameOf(p).toLowerCase() === name.toLowerCase());
  return key ? files[key]() : null;
}
